export default __webpack_public_path__ + "static/media/404.79a9acce.svg";